import HttpRequest from './http_request'

class payInSlipProvider extends HttpRequest {
  constructor() {
    // api api
    super(process.env.VUE_APP_API_URL)
  }

  //ข้อมูลใบจ่ายเงิน
  async getPaymentTuitionFee(level_id, year, semester, student_id, sub_level_id = null, as_student = false) {
    const { data } = await this.get('/', {
      function: 'get-payment-tuition-fee',
      level_id: level_id,
      year: year,
      semester: semester,
      student_id: student_id,
      sub_level_id: sub_level_id,
      as_student: as_student ? 1 : 0,
    })
    return data
  }

  async getPaymentData({ level_id, year = null, semester = null, student_id, sub_level_id = null }) {
    const { data } = await this.get('/', {
      function: 'get-payment-data',
      level_id: level_id,
      year: year,
      semester: semester,
      student_id: student_id,
      sub_level_id: sub_level_id,
    })
    return data
  }

  async getPaymentBillingDetails({ level_id, sub_level_id = null, student_id, year, semester }) {
    const { data } = await this.get('/', {
      function: 'get-payment-billing-details',
      level_id,
      sub_level_id,
      student_id,
      year,
      semester,
    })
    return data
  }

  async getPaymentBillingCodes(level_id) {
    const { data } = await this.get('/', {
      function: 'get-payment-billing-codes',
      level_id,
    })
    return data
  }

  // แก้ไขค่าธรรมเนียมจากหน้าชำระเงินสำหรับเจ้าหน้าที่
  async updatePaymentTuitionFee({ level_id, sub_level_id = null, student_id, year, semester, tuition_fee }) {
    const { data } = await this.update('/', {
      function: 'update-payment-tuition-fee',
      level_id,
      sub_level_id,
      student_id,
      year,
      semester,
      tuition_fee,
    })
    return data
  }

  async updatePaymentOtherFees({ level_id, sub_level_id = null, student_id, year, semester, subsidy_fee, thesis_fee, compre_fee, qe_fee }) {
    const { data } = await this.update('/', {
      function: 'update-payment-other-fees',
      level_id,
      sub_level_id,
      student_id,
      year,
      semester,
      subsidy_fee,
      thesis_fee,
      compre_fee,
      qe_fee,
    })
    return data
  }

  async updatePaymentPenaltyCharge({ level_id, sub_level_id = null, student_id, year, semester, charge_type, is_exempt }) {
    const { data } = await this.update('/', {
      function: 'update-payment-penalty-charge',
      level_id,
      sub_level_id,
      student_id,
      year,
      semester,
      charge_type,
      is_exempt: is_exempt ? 1 : 0,
    })
    return data
  }

  async updatePaymentBillingDetail({ level_id, sub_level_id = null, student_id, year, semester, bill_no, details }) {
    const { data } = await this.update('/', {
      function: 'update-payment-billing-detail',
      level_id,
      sub_level_id,
      student_id,
      year,
      semester,
      bill_no,
      details: JSON.stringify(details),
    })
    return data
  }

  async createPaymentBillingDetail({ level_id, sub_level_id = null, student_id, year, semester, details }) {
    const { data } = await this.create('/', {
      function: 'create-payment-billing-detail',
      level_id,
      sub_level_id,
      student_id,
      year,
      semester,
      details: JSON.stringify(details),
    })
    return data
  }

  async deletePaymentBillingDetail({ level_id, sub_level_id = null, student_id, year, semester, bill_no, reason }) {
    const { data } = await this.delete('/', {
      function: 'delete-payment-billing-detail',
      level_id,
      sub_level_id,
      student_id,
      year,
      semester,
      bill_no,
      reason,
    })
    return data
  }

  async getPaymentStudentNotes(student_id) {
    const { data } = await this.get('/', {
      function: 'get-payment-student-notes',
      student_id,
    })
    return data
  }

  async createPaymentStudentNote({ student_id, note }) {
    const { data } = await this.create('/', {
      function: 'create-payment-student-note',
      student_id,
      note,
    })
    return data
  }

  async updatePaymentStudentNote({ student_id, timestamp, note_user_id, note }) {
    const { data } = await this.update('/', {
      function: 'update-payment-student-note',
      student_id,
      timestamp,
      note_user_id,
      note,
    })
    return data
  }

  async deletePaymentStudentNote({ student_id, timestamp, note_user_id }) {
    const { data } = await this.delete('/', {
      function: 'delete-payment-student-note',
      student_id,
      timestamp,
      note_user_id,
    })
    return data
  }

  // ข้อมูลสำหรับสร้างหน้าจ่ายเงิน Fastpay
  async getFastpayOrder({ ref_1, bank_info_id, system_id, pay_for_id, year, semester, level_payment_id, reserved, amount }) {
    const { data } = await this.get('/', {
      function: 'get-fastpay-order',
      ref_1: ref_1,
      bank_info_id: bank_info_id,
      system_id: system_id,
      pay_for_id: pay_for_id,
      year: year,
      semester: semester,
      level_payment_id: level_payment_id,
      reserved: reserved,
      amount: amount,
    })
    return data
  }

}

export default payInSlipProvider
